import { defineMessages } from 'react-intl';

export default defineMessages({
    roofUpdate: {
        "id": "twia.commercialPolicySummary.view.Roofing Update",
        "defaultMessage": "Roofing Update"
    },
    addedLivingSpace: {
        "id": "twia.CommercialPolicySummary.view.Added Living Space - Roofing Updates",
        "defaultMessage": "Added Living Space - Roofing Updates"
    },
    repairsAdditions: {
        "id": "twia.CommercialPolicySummary.view.Repairs/Additions",
        "defaultMessage": "Repairs/Additions"
    },
    addedLivingSpaceRepairsAddition: {
        "id": "twia.CommercialPolicySummary.view.Added Living Space - Repairs/Additions",
        "defaultMessage": "Added Living Space - Repairs/Additions"
    }
})